import type React from "react";
import Image from "next/image";
import RedactNewsLetter from "../../public/images/aiOptOut/common/redacto-news-letter.svg";
import RedactText from "./optout-general-components/redacttext";
import RedactModal from "./optout-general-components/redactmodal";
import TailwindButton from "../general/tailwindButton";
import { useState } from "react";

const NewsLetter = () => {
  const [value, setValue] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalText, setModalText] = useState("");

  const validateEmail = (email: string) => {
    const regex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
    return regex.test(email);
  };

  const handleEmailChange = (event: any) => {
    setValue(event.target.value);
  };

  const insertIntoDB = async (dbEmailValue: string) => {
    console.log("Setting new view");
    // const { data, error } = await supabase
    //     .from("newsletter")
    //     .insert({
    //         email: dbEmailValue
    //     })

    // if (data) {
    //     console.log(data);
    // }
    // if (error) {
    //     console.log(error);
    // }
  };

  const sendEmail = (emailValue: string) => {
    if (value.length > 0 && validateEmail(emailValue)) {
      insertIntoDB(emailValue);
      setModalTitle("Thank you for joining our newsletter!");
      setModalText("We'll be in touch with more helpful digital privacy updates!");
    } else {
      setModalTitle("Error!");
      setModalText("Please verify the email you inserted is valid.");
    }
    setShowModal(true);
    setValue("");
  };
  return (
    <div className="flex w-full items-end justify-center sm:mt-10 mt-10 ">
      <div className="flex w-[350px] h-[630px] sm:w-[1013px] sm:h-[348px] items-end justify-center sm:mt-20 bg-gradient-to-r from-brand-blue/40 to-brand-purple rounded-xl">
        <div className="flex w-[346px] h-[626px] sm:w-[1009px] sm:h-[344px] mb-[1px]">
          <div className="flex w-full sm:w-[1013px] h-[624px] sm:h-[343px] bg-brand-gray900 rounded-xl">
            <div className="flex flex-col sm:flex-row-reverse ">
              <div className="flex justify-center mt-10 sm:mt-0 sm:justify-end w-full sm:ml-20">
                <Image
                  src={RedactNewsLetter}
                  alt="Redact News Letter"
                  className=""
                  width={310}
                  height={0}
                  priority
                />
              </div>
              <div className="flex flex-col sm:ml-10 w-full mt-5">
                <div className="flex justify-center sm:justify-start">
                  <RedactText
                    color="text-redactWhite text-center sm:text-left font-bold"
                    size="text-[32px] sm:text-[51px] mt-7"
                    text={"Get More Guides"}
                  />
                </div>
                <div className="flex justify-center sm:justify-start mt-10 sm:w-[500px]">
                  <RedactText
                    color="text-redactWhite text-center sm:text-left font-normal"
                    size="text-[16px] mt-2"
                    text={
                      "Sign up to the Redact newsletter for free digital privacy guides, news, and promotions."
                    }
                  />
                </div>
                <form className="flex justify-center sm:justify-start">
                  <div className="mt-5">
                    <input
                      className="appearance-none  rounded-md sm:w-[406px] h-[56px] py-2 px-3 text-redactWhite bg-redactThreatBlack leading-tight focus:shadow-outline text-xl"
                      id="Email"
                      type="text"
                      placeholder="Email"
                      onChange={handleEmailChange}
                      value={value}
                    />
                  </div>
                </form>
                <div className="flex justify-center sm:justify-start w-full mt-5">
                  <TailwindButton
                    buttonBGColor="bg-brand-slate"
                    buttonBorderColor="border-brand-purple"
                    buttonHeight="h-[38px]"
                    buttonTextTailwindStyle="font-bold text-[16px]"
                    buttonText="Join the Newsletter"
                    buttonWidth="w-[200px]"
                    onClick={() => sendEmail(value)}
                    buttonURL={undefined}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showModal ? (
        <RedactModal
          handleChange={() => setShowModal(false)}
          modalTitle={modalTitle}
          modalText={modalText}
        />
      ) : null}
    </div>
  );
};

export default NewsLetter;
